/**
 * Define alert/confirm plugin
 *
 * @author minkyoung.park@emcast.com
 */
import AlertModal from './AlertModal.vue'

const alertPlugin = {
    install(Vue, optiuons) {
        let alertConstructor = Vue.extend(AlertModal)
        let alertInstance = null

        alertInstance = new alertConstructor({
            el: document.createElement('div')
        })

        alertInstance.attachMaterial(alertInstance.$el)
        document.body.appendChild(alertInstance.$el)

        Vue.prototype.$alert = function (payload) {
            return new Promise((resolve, reject) => {
                alertInstance.open(payload, false).then((data) => {
                    resolve(data)
                }).catch((err) => {
                    reject(err)
                })
            })
        }

        const confirmOptions = {autoClose: false, time: 1000};
        Vue.prototype.$confirm = function (payload, options = confirmOptions) {
            return new Promise((resolve, reject) => {
                alertInstance.open(payload, true).then((data) => {
                    resolve(data)
                }).catch((err) => {
                    reject(err)
                });

                if (options.autoClose) {
                    setTimeout(() => alertInstance.onCancel(), options.time);
                }
            })
        }
        Vue.prototype.$error = Vue.prototype.$alert
        Vue.prototype.$ok = Vue.prototype.$alert
        Vue.prototype.$info = Vue.prototype.$alert
    }
}

export default alertPlugin
